const getExperienceDesc = exp =>
  ({
    1: '< 1 year',
    2: '1-3 years',
    3: '3-5 years',
    4: '+5 years'
  }[exp]);
export default getExperienceDesc;
